import { createAction } from "@reduxjs/toolkit";
import { ContractsListParams } from "./types";

export const getContractsList = createAction<ContractsListParams>(
    'contracts/getContractsList',
  );